// Skills v2 — live SKILL.md validation display. Shows the actionable issues the
// backend validator returns (errors block publish; warnings advise), so an
// author knows exactly what to fix and where, instead of a generic "invalid".
import { COLORS } from "../../theme/colors";

const RED = COLORS.red || "#ef4444";
const AMBER = COLORS.orange || "#f59e0b";
const GREEN = COLORS.green || "#10b981";

export default function SkillValidationIssues({ issues }) {
  const list = Array.isArray(issues) ? issues : [];
  const errors = list.filter((i) => i.severity === "error");
  const warnings = list.filter((i) => i.severity === "warning");

  if (!list.length) {
    return (
      <div style={{ fontSize: 12.5, color: GREEN, marginTop: 10, display: "flex", alignItems: "center", gap: 6 }}>
        <span aria-hidden="true">✓</span> Looks good — this SKILL.md will parse and publish.
      </div>
    );
  }

  return (
    <div role="status" aria-label="Skill validation issues"
      style={{ marginTop: 10, display: "flex", flexDirection: "column", gap: 6 }}>
      {errors.length > 0 && (
        <div style={{ fontSize: 11, fontWeight: 700, color: RED, letterSpacing: "0.03em", textTransform: "uppercase" }}>
          {errors.length} thing{errors.length === 1 ? "" : "s"} to fix before publishing
        </div>
      )}
      {errors.map((i, k) => <Row key={`e${k}`} issue={i} color={RED} icon="✕" />)}
      {warnings.map((i, k) => <Row key={`w${k}`} issue={i} color={AMBER} icon="⚠" />)}
    </div>
  );
}

function Row({ issue, color, icon }) {
  return (
    <div style={{ fontSize: 12.5, color: COLORS.text, display: "flex", gap: 8, alignItems: "flex-start" }}>
      <span style={{ color, fontWeight: 800, flex: "0 0 auto" }} aria-hidden="true">{icon}</span>
      <span>
        {issue.line
          ? <b style={{ color }}>{`Line ${issue.line}: `}</b>
          : (issue.field ? <b style={{ color }}>{`${issue.field}: `}</b> : null)}
        {issue.message}
      </span>
    </div>
  );
}
